import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Disclaimers, User, UserDetails } from 'app/core/auth/user.model';
import { Resource } from 'app/shared/acl/acl.model';
import { skipWhile, take } from 'rxjs/operators';
import { updateUser } from './auth.actions';
import {
    getAuthToken,
    getFilledCredentials,
    getParagonTableQuotaLeft,
    getPropertiesTableQuotaLeft,
    getUserInfo,
    getUserInfoLoaded
} from './auth.reducer';
import { AuthService } from './auth.service';


@Injectable({
    providedIn: 'root',
})
export class AuthQuery {

    constructor(private store: Store, private authService: AuthService) {}

    getUserInfo$() {
        return this.store.select(getUserInfo);
    }

    getUserInfoLoaded$() {
        return this.store.select(getUserInfoLoaded);
    }

    getFilledCredentials() {
        return this.store.select(getFilledCredentials);
    }

    getPropertiesTableQuotaLeft$() {
        return this.store.select(getPropertiesTableQuotaLeft);
    }

    getParagonTableQuotaLeft$() {
        return this.store.select(getParagonTableQuotaLeft);
    }

    getAuthToken$() {
        return this.store.select(getAuthToken);
    }

    withAuthToken$() {
        return this.getAuthToken$().pipe(skipWhile(value => !value), take(1));
    }

    whenUserInfoLoaded$() {
        return this.getUserInfoLoaded$().pipe(skipWhile(value => !value), take(1));
    }

    updateUser(update: { user?: Partial<User>, details?: Partial<UserDetails>, resources?: Resource[], disclaimers?: Disclaimers }) {
        this.store.dispatch(updateUser(update));
    }

    refreshUser() {
        this.authService.refreshUser();
    }
}
